import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

/** Hairline end-of-article row with the way back to the index. */
export function BlogPostFooter() {
  return (
    <footer className="mt-14 flex items-center justify-between gap-4 border-t border-[var(--color-border)] pt-6">
      <Link
        to="/blogs"
        search={{ page: 1 }}
        className="inline-flex items-center gap-2 rounded-full text-body-sm font-medium text-[var(--color-text-secondary)] transition-colors duration-300 ease-brisk hover:text-[var(--color-text-primary)] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary/50"
      >
        <ArrowLeft className="h-4 w-4" />
        All posts
      </Link>
      <span className="font-mono text-caption text-[var(--color-text-tertiary)]">
        end of article
      </span>
    </footer>
  )
}
